import React from 'react';
import FileIcon from 'src/common/utils/TableColumnIcons/FileIcon';

export const ActionColumnDetails = (value, row, rowIndex, { onFile }) => {
	 

	return (
		<>
			<FileIcon onClick={() => onFile(row)} color="#808080" />
		</>
	);
};
